import React, { useEffect, useRef, useState } from 'react'
import { createLocalizedPath } from '../../../../utils/localizationHelpers'
import paths from '../../../../paths'
import { followUser, unfollowUser } from '../../../../store/member/memberSlice'
import { isUserPro } from '../../../../utils/isUserPro'
import { openPremiumDialog } from '../../../../store/common/commonSlice'
import { checkIsFollowingUser } from '../../../../utils/isFollowingUser'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { RootState } from '../../../../store/rootReducer'
import { EmphemeralPostType } from '../../../../store/ephemeral/ephemeralTypings'

const UserMenu = ({ post }: { post: EmphemeralPostType }) => {
    const [t] = useTranslation()

    const history = useHistory()
    const dispatch = useDispatch()

    const user = useSelector((state: RootState) => state.member.user)

    const [hasCheckedFollowing, setHasCheckedFollowing] = useState(false)
    const [followed, setFollowed] = useState(false)
    const menuRef = useRef<HTMLDivElement>(null)

    const handleOpenProfile = (e: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => {
        e.stopPropagation()
        history.push(createLocalizedPath(paths.profile.toPath({ nick: post.user.nick })))
    }

    const handleFollowUnfollowUser = (e: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => {
        e.stopPropagation()
        followed ? dispatch(unfollowUser({ id: post.user.id })) : dispatch(followUser({ id: post.user.id }))
        setFollowed(!followed)
    }

    const handleBlockUser = (e: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => {
        e.stopPropagation()
        isUserPro(user.member_type)
            ? history.push({
                  pathname: createLocalizedPath(paths.myBlacklist.path),
                  search: `?user=${post.user.nick}`
              })
            : dispatch(openPremiumDialog())
    }

    const handleGiftPremium = (e: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => {
        e.stopPropagation()
        history.push({
            pathname: createLocalizedPath(paths.payment.path),
            search: `?gift=${post.user.nick}`
        })
    }

    useEffect(() => {
        if (!post || hasCheckedFollowing || !menuRef.current) {
            // @ts-ignore
            return
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    const fetchIsFollowing = async () => {
                        setFollowed(await checkIsFollowingUser(post.user.id))
                        setHasCheckedFollowing(true)
                    }
                    fetchIsFollowing()
                    observer.disconnect()
                }
            },
            {
                threshold: 0.1,
                root: null,
                rootMargin: '0px'
            }
        )
        observer.observe(menuRef.current)

        return () => {
            observer.disconnect()
        }
    }, [post, hasCheckedFollowing])

    return (
        <>
            <p className="profile" onClick={(e) => handleOpenProfile(e)} ref={menuRef}>
                {t('Profile')}
            </p>
            <p className={followed ? 'unfollow' : 'follow'} onClick={(e) => handleFollowUnfollowUser(e)}>
                {followed ? t('unfollow') : t('follow')}
            </p>
            <p className="block" onClick={(e) => handleBlockUser(e)}>
                {t('Block')}
            </p>
            <p
                className={
                    'premiumBob'
                    // : 'premiumBob noBottomBorder'
                }
                onClick={(e) => handleGiftPremium(e)}
            >
                {t('Give Premium')}
            </p>
        </>
    )
}

export default UserMenu
